import { useState } from 'react';

const WA_LINK = "https://wa.me/243808631779?text=Bonjour%20je%20souhaite%20m'inscrire%20à%20une%20formation";

const testimonials = [
  {
    id: 1,
    name: 'Jean-Pierre Mukendi',
    role: 'Technicien Solaire — Diplômé 2024',
    quote: 'Grâce à Campus Négus Tech, j\'ai appris à installer des systèmes solaires en seulement 2 mois. Aujourd\'hui j\'ai ma propre entreprise et je travaille sur des projets à travers tout Kinshasa. La formation pratique m\'a vraiment préparé au terrain.',
    highlight: 'ma propre entreprise',
    rating: 5,
    image: 'https://public.readdy.ai/ai/img_res/081adb7e21e4bc3b15e3375cfcd5c995.jpg',
    program: 'Énergie Solaire',
  },
  {
    id: 2,
    name: 'Marie-Claire Kabila',
    role: 'Développeuse Web — Diplômée 2024',
    quote: 'Je ne savais rien du code avant d\'entrer à Campus Négus Tech. En 4 mois, j\'ai créé mon premier site web professionnel et décroché un contrat avec une ONG internationale. Les formateurs sont exceptionnels et très patients.',
    highlight: 'contrat avec une ONG internationale',
    rating: 5,
    image: 'https://readdy.ai/api/search-image?query=young%20African%20woman%20professional%20developer%20confident%20portrait%20Kinshasa%20DRC&width=200&height=240&seq=test002&orientation=portrait',
    program: 'Développement Web',
  },
  {
    id: 3,
    name: 'Patrick Lumumba',
    role: 'Technicien Fibre Optique — Diplômé 2023',
    quote: 'La formation en fibre optique de Campus Négus Tech est la meilleure de Kinshasa. J\'ai été recruté par une grande entreprise de télécommunications dès la fin de ma formation. Le réseau de partenaires du campus est vraiment précieux.',
    highlight: 'recruté par une grande entreprise',
    rating: 5,
    image: 'https://readdy.ai/api/search-image?query=young%20African%20man%20professional%20telecommunications%20technician%20confident%20portrait%20DRC&width=200&height=240&seq=test003&orientation=portrait',
    program: 'Fibre Optique',
  },
  {
    id: 4,
    name: 'Sandrine Tshilombo',
    role: 'Technicienne CCTV — Diplômée 2024',
    quote: 'En tant que femme dans un domaine technique, j\'avais des doutes. Campus Négus Tech m\'a accueillie avec bienveillance et j\'ai acquis toutes les compétences nécessaires. Maintenant je gère des installations de sécurité pour des banques.',
    highlight: 'installations de sécurité pour des banques',
    rating: 5,
    image: 'https://readdy.ai/api/search-image?query=young%20African%20woman%20professional%20security%20technician%20confident%20portrait%20Kinshasa&width=200&height=240&seq=test004&orientation=portrait',
    program: 'Sécurité & CCTV',
  },
];

export default function TestimonialsSection() {
  const [current, setCurrent] = useState(0);

  const prev = () => setCurrent((c) => (c - 1 + testimonials.length) % testimonials.length);
  const next = () => setCurrent((c) => (c + 1) % testimonials.length);

  const t = testimonials[current];

  return (
    <section id="temoignages" className="py-24 bg-[#0a1628] relative overflow-hidden">
      {/* Background decoration */}
      <div className="absolute top-0 left-0 w-full h-full opacity-5">
        <div className="absolute top-10 left-10 w-64 h-64 rounded-full bg-[#f5c518]"></div>
        <div className="absolute bottom-10 right-10 w-48 h-48 rounded-full bg-[#f5c518]"></div>
      </div>

      <div className="relative z-10 max-w-7xl mx-auto px-6 md:px-10">
        {/* Header */}
        <div className="text-center mb-16">
          <span className="inline-block bg-[#f5c518]/20 text-[#f5c518] text-sm font-semibold px-4 py-1.5 rounded-full mb-4">
            Témoignages
          </span>
          <h2 className="text-4xl md:text-5xl font-black text-white mb-3">
            Ce que disent nos étudiants
          </h2>
          <p className="text-white/50 text-base">Avis vérifiés de nos diplômés</p>
        </div>

        {/* Main Testimonial Card */}
        <div className="bg-white/5 border border-white/10 rounded-3xl p-8 md:p-12 mb-8">
          <div className="flex flex-col lg:flex-row gap-10 items-center">
            {/* Photo */}
            <div className="flex-shrink-0 relative">
              <div className="w-48 h-56 rounded-2xl overflow-hidden bg-[#f5c518]/20">
                <img
                  src={t.image}
                  alt={t.name}
                  className="w-full h-full object-cover object-top"
                />
              </div>
              <div className="absolute -bottom-3 -right-3 bg-[#f5c518] rounded-xl px-3 py-1.5">
                <span className="text-[#0a1628] text-xs font-bold">{t.program}</span>
              </div>
            </div>

            {/* Content */}
            <div className="flex-1">
              {/* Stars */}
              <div className="flex gap-1 mb-5">
                {Array.from({ length: t.rating }).map((_, i) => (
                  <div key={i} className="w-5 h-5 flex items-center justify-center">
                    <i className="ri-star-fill text-[#f5c518] text-lg"></i>
                  </div>
                ))}
              </div>

              {/* Quote */}
              <div className="w-8 h-8 flex items-center justify-center mb-4">
                <i className="ri-double-quotes-l text-[#f5c518] text-4xl opacity-60"></i>
              </div>
              <p className="text-white/85 text-lg md:text-xl leading-relaxed mb-6">
                {t.quote}
              </p>

              {/* Author */}
              <div className="flex items-center gap-4">
                <div className="w-px h-10 bg-[#f5c518]"></div>
                <div>
                  <div className="text-white font-bold text-lg">{t.name}</div>
                  <div className="text-white/50 text-sm">{t.role}</div>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Navigation & Dots */}
        <div className="flex items-center justify-between">
          {/* Dots */}
          <div className="flex gap-2">
            {testimonials.map((_, i) => (
              <button
                key={i}
                onClick={() => setCurrent(i)}
                className={`h-2 rounded-full transition-all duration-300 cursor-pointer ${
                  i === current ? 'bg-[#f5c518] w-8' : 'bg-white/30 w-2'
                }`}
                aria-label={`Témoignage ${i + 1}`}
              />
            ))}
          </div>

          {/* Arrows */}
          <div className="flex gap-3">
            <button
              onClick={prev}
              className="w-12 h-12 flex items-center justify-center border-2 border-white/30 rounded-full text-white hover:border-[#f5c518] hover:text-[#f5c518] transition-all duration-200 cursor-pointer"
              aria-label="Précédent"
            >
              <i className="ri-arrow-left-line text-lg"></i>
            </button>
            <button
              onClick={next}
              className="w-12 h-12 flex items-center justify-center bg-[#f5c518] rounded-full text-[#0a1628] hover:bg-yellow-400 transition-all duration-200 cursor-pointer"
              aria-label="Suivant"
            >
              <i className="ri-arrow-right-line text-lg"></i>
            </button>
          </div>
        </div>

        {/* Bottom CTA */}
        <div className="text-center mt-14 p-8 bg-[#f5c518]/10 border border-[#f5c518]/20 rounded-2xl">
          <p className="text-white text-xl font-bold mb-2">Rejoignez nos 500+ diplômés !</p>
          <p className="text-white/60 text-sm mb-6">Commencez votre formation dès aujourd'hui et transformez votre avenir.</p>
          <a
            href={WA_LINK}
            target="_blank"
            rel="noopener noreferrer"
            className="inline-flex items-center gap-3 bg-[#f5c518] text-[#0a1628] font-bold text-base px-10 py-4 rounded-full hover:bg-yellow-400 transition-all duration-300 hover:scale-105 whitespace-nowrap cursor-pointer"
          >
            <div className="w-6 h-6 flex items-center justify-center">
              <i className="ri-whatsapp-line text-lg"></i>
            </div>
            Je veux m'inscrire maintenant
          </a>
        </div>
      </div>
    </section>
  );
}
